var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { BaseTaskPayload } from './base-payload';
var ProcessTaskPayload = /** @class */ (function (_super) {
    __extends(ProcessTaskPayload, _super);
    function ProcessTaskPayload(calculateProgressUpdated) {
        return _super.call(this, calculateProgressUpdated) || this;
    }
    ProcessTaskPayload.prototype.toSetProcedureCompleted = function (hashid, completed) {
        return _super.prototype.toSetProcedureCompleted.call(this, hashid, completed);
    };
    ProcessTaskPayload.prototype.toSetDecisionStepCompleted = function (stepId, choice) {
        return this.toUpdateProcedure(stepId, {
            set_completed: this.getCompletedValueFor(choice != null),
            set_choice: choice,
        });
    };
    ProcessTaskPayload.prototype.toSetCompleted = function (completed) {
        return this.toSetTaskCompleted(completed);
    };
    return ProcessTaskPayload;
}(BaseTaskPayload));
export { ProcessTaskPayload };
